import { class_type } from "../fable-library.3.7.1/Reflection.js";
import { value, some } from "../fable-library.3.7.1/Option.js";

export class PopperModifier {
    constructor() {
        this.modifier = {};
    }
}

export function PopperModifier$reflection() {
    return class_type("Fable.PopperJS.CreatePopper.PopperModifier", void 0, PopperModifier);
}

export function PopperModifier_$ctor() {
    return new PopperModifier();
}

export function PopperModifier__withName_Z721C83C5(this$, name) {
    this$.modifier.name = name;
    return this$;
}

export function PopperModifier__withEnabled_Z1FBCCD16(this$, enabled) {
    this$.modifier.enabled = enabled;
    return this$;
}

export function PopperModifier__withPhase_793FC4BD(this$, phase) {
    this$.modifier.phase = phase;
    return this$;
}

export function PopperModifier__withRequires_35E31878(this$, requires) {
    this$.modifier.requires = requires;
    return this$;
}

export function PopperModifier__withRequiresIfExists_35E31878(this$, requiresIfExists) {
    this$.modifier.requiresIfExists = requiresIfExists;
    return this$;
}

export function PopperModifier__withFn_Z3A805D2(this$, fn) {
    this$.modifier.fn = fn;
    return this$;
}

export function PopperModifier__withEffect_Z351C96CE(this$, effect) {
    this$.modifier.effect = effect;
    return this$;
}

export function PopperModifier__withOptions_4E60E31B(this$, options) {
    this$.modifier.options = some(options);
    return this$;
}

export function PopperModifier__withData_7BC6271A(this$, data) {
    this$.modifier.data = data;
    return this$;
}

export function PopperModifier__Finalize(this$) {
    return this$.modifier;
}

export class PopperOptions {
    constructor() {
        this.options = {};
    }
}

export function PopperOptions$reflection() {
    return class_type("Fable.PopperJS.CreatePopper.PopperOptions", void 0, PopperOptions);
}

export function PopperOptions_$ctor() {
    return new PopperOptions();
}

export function PopperOptions__withPlacement_Z2582A330(this$, p) {
    this$.options.placement = p;
    return this$;
}

export function PopperOptions__withModifiers_333947E4(this$, m) {
    this$.options.modifiers = m;
    return this$;
}

export function PopperOptions__withAddedModifier_174A2785(this$, m) {
    const matchValue = this$.options.modifiers;
    if (matchValue == null) {
        this$.options.modifiers = [PopperModifier__Finalize(m)];
    }
    else {
        void (value(this$.options.modifiers).push(PopperModifier__Finalize(m)));
    }
    return this$;
}

export function PopperOptions__withStrategy_2F2221DF(this$, s) {
    this$.options.strategy = s;
    return this$;
}

export function PopperOptions__withOnFirstUpdate_59A2A224(this$, f) {
    this$.options.onFirstUpdate = f;
    return this$;
}

export function PopperOptions__Finalize(this$) {
    return this$.options;
}

export class Popper {
    constructor() {
    }
}

export function Popper$reflection() {
    return class_type("Fable.PopperJS.CreatePopper.Popper", void 0, Popper);
}

export function Popper_$ctor() {
    return new Popper();
}

